import { API_BASE, axiosApi } from "../config"
import { CreateWellReturnInterface, GeneralReturnInterface, GetAllPlatesReturnInterface, GetPlateReturnInterface, PlateStatusType, SampleInterfaceWithWellIdx } from "../types"


export const savePlate = async (body:{samples:SampleInterfaceWithWellIdx[], type:'96well'|'384well'}): Promise<GeneralReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/savePlate`,body)).data
}

export const getPlate = async (body:{plateId:number}): Promise<GetPlateReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/getPlate`,body)).data
}


export const getAllPlates = async (): Promise<GetAllPlatesReturnInterface> => {
  return (await axiosApi.post(`${API_BASE}/plates`)).data
}

export async function createWell(body: { plateId: number, wellidx: number, sampleId: string | number | null }):Promise<CreateWellReturnInterface> {
    return (await axiosApi.post(`${API_BASE}/createWell`,body)).data
}


export async function updatePlateStatus(body: { plateId: number, newStatus:PlateStatusType }):Promise<GeneralReturnInterface>  {
    return (await axiosApi.post(`${API_BASE}/updatePlateStatus`,body)).data
}

export async function updatePlateNotes(body: { plateId: number, notes: string }): Promise<GeneralReturnInterface> {
  return (await axiosApi.post(`${API_BASE}/updatePlateNotes`, body)).data
}

export async function updateWellPriority(body: { wellId: number, priority: number }): Promise<GeneralReturnInterface> {
  return (await axiosApi.post(`${API_BASE}/updateWellPriority`, body)).data
}
